/**
 * i18n 配置
 */
import { createI18n } from 'vue-i18n'
import Cookies from 'js-cookie'

import en_US from '@/locales/en.json'
import pt from '@/locales/pt.json'
import vi from '@/locales/vi.json'
import zh_CN from '@/locales/zh.json'
import jp from '@/locales/jp.json'
import zh_tw from '@/locales/zh_tw.json'

// 浏览器语言映射
const LANGUAGE_MAP: Record<string, string> = {
    zh: 'zh_CN',
    'zh-cn': 'zh_CN',
    'zh-CN': 'zh_CN',
    'zh-TW': 'zh_tw',
    'zh-tw': 'zh_tw',
    'zh-HK': 'zh_tw',
    'zh-MO': 'zh_tw',
    en: 'en_US',
    ja: 'jp',
    pt: 'pt',
    vi: 'vi',
    ko: 'en_US',
}

// 获取初始语言：Cookie > 环境变量默认值
const cookieLang = Cookies.get('lang')
let locale = cookieLang || import.meta.env.VITE_LANG || 'zh_CN'

// 根据渠道判断默认语言
if (!cookieLang) {
    const channel = import.meta.env.VITE_CHANNEL || ''
    if (channel === 'ty121' || channel === 'ty122') {
        locale = 'zh_tw'
    } else if (['jtj', 'jz0901', 'dev', 'test'].includes(channel)) {
        locale = 'zh_CN'
    } else {
        locale = 'en_US'
    }
    Cookies.set('lang', locale)
}

const i18n = createI18n({
    legacy: false,
    locale,
    messages: {
        en_US,
        pt,
        vi,
        zh_CN,
        jp,
        zh_tw,
    },
})

export default i18n
